import "antd/es/modal/style";
import _Modal from "antd/es/modal";
import "antd/es/tag/style";
import _Tag from "antd/es/tag";
import _extends from "babel-runtime/helpers/extends";
import "antd/es/dropdown/style";
import _Dropdown from "antd/es/dropdown";
import "antd/es/avatar/style";
import _Avatar from "antd/es/avatar";
import _Promise from "babel-runtime/core-js/promise";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import "antd/es/menu/style";
import _Menu from "antd/es/menu";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useState } from "react";
import { DownOutlined, RightOutlined, UserOutlined, FormOutlined, LogoutOutlined } from "@ant-design/icons";

import qs from "qs";
import { getConfigNavMenu, getProjectId, getCompanyId, getCurrentProjectConfigured, getToken, removeToken, clearToken, userMsg, isGrayUser, getSpecialKeys, getSpecial, isJcbUser, getProjectInfoById, getServiceList } from "jcb-token-kit";
import { homeNy, homeCity, projectIds, customNavCompanyIds } from "../utils/constant";
import { showWorkSpaceProjectIds, isShowWorkSpace, isInnerWorkSpace, menusWorkSpace, isOnlyShowJcb, isBackProjects, isShangZhuang } from "../utils/custom-project";
import { isShowProjectList, isShowDownload } from "../utils/custom-show";
import usePage from "./usePage";
import useDomain from "./useDomain";
import useCustomized from "./useCustomized";
import useCache from "./useCache";
import cx from "classnames";
import defaultLogo from "../assets/logo@2x.png";
import downloadPng from "../assets/download.jpg";
import downloadPngd from "../assets/downloadPng_d.png";
import downloadImg from "../assets/download.png";
import cdownloadImg from "../assets/download_.png";
import projectsImg from "../assets/projects.png";
import qrCode from "../assets/qrcode.jpg";
import customerImg from "../assets/customer.png";
import kfImg from "../assets/kefu.png";
import logoutImg from "../assets/logout.png";
import appCodeDev from "../assets/app_ccheng_dev.png";
import appCodeRelease from "../assets/app_ccheng_release.png";
import appCodeNy from "../assets/app_ny.png";
import nyLogo from "../assets/logo_ny.png";
import MenuTrigger from "./MenuTrigger";
import "./NavMenu.css";

var _usePage = usePage(),
    updateTitleAndFavicon = _usePage.updateTitleAndFavicon,
    updateThemeColor = _usePage.updateThemeColor;

var _useCache = useCache(),
    getProjectName = _useCache.getProjectName;

var DEAlDOMAIN = "yuanlin.oopsdata.com";
var CURRENTDOMAIN = window.location.host;
var LINKTYPE = {
  CURRENT: 1,
  NEW: 2,
  SUBPROJECT: 3
};

var LINKTARGET = {
  INTERNAL: "internal",
  EXTERNAL: "external"
};

var SubMenu = _Menu.SubMenu;


var NavMenuCopy = function NavMenuCopy(_ref) {
  var _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === undefined ? 1000 : _ref$minWidth,
      _ref$onLogout = _ref.onLogout,
      onLogout = _ref$onLogout === undefined ? function () {} : _ref$onLogout,
      _ref$onRoleChange = _ref.onRoleChange,
      onRoleChange = _ref$onRoleChange === undefined ? function () {} : _ref$onRoleChange,
      _ref$cache = _ref.cache,
      cache = _ref$cache === undefined ? false : _ref$cache,
      _ref$download = _ref.download,
      download = _ref$download === undefined ? {} : _ref$download,
      _ref$menuList = _ref.menuList,
      menuList = _ref$menuList === undefined ? [] : _ref$menuList,
      _ref$allRoles = _ref.allRoles,
      allRoles = _ref$allRoles === undefined ? [] : _ref$allRoles,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === undefined ? false : _ref$fixed,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "menu" : _ref$type,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$moduleName = _ref.moduleName,
      moduleName = _ref$moduleName === undefined ? "" : _ref$moduleName,
      _ref$userName = _ref.userName,
      userName = _ref$userName === undefined ? "" : _ref$userName,
      _ref$avatar = _ref.avatar,
      avatar = _ref$avatar === undefined ? "" : _ref$avatar,
      _ref$homeUrl = _ref.homeUrl,
      homeUrl = _ref$homeUrl === undefined ? "" : _ref$homeUrl,
      _ref$dashboardUrl = _ref.dashboardUrl,
      dashboardUrl = _ref$dashboardUrl === undefined ? "" : _ref$dashboardUrl,
      _ref$logo = _ref.logo,
      logo = _ref$logo === undefined ? null : _ref$logo,
      _ref$isSubTitle = _ref.isSubTitle,
      isSubTitle = _ref$isSubTitle === undefined ? false : _ref$isSubTitle,
      _ref$downloadVisible = _ref.downloadVisible,
      downloadVisible = _ref$downloadVisible === undefined ? true : _ref$downloadVisible,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === undefined ? function () {} : _ref$onToggle,
      _ref$hasSide = _ref.hasSide,
      hasSide = _ref$hasSide === undefined ? false : _ref$hasSide,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? false : _ref$collapsed,
      history = _ref.history;

  var _useCustomized = useCustomized(),
      isCompany = _useCustomized.isCompany;

  var showLogo = process.env.REACT_APP_TYPE === "ny" ? nyLogo : defaultLogo;
  var layoutUrl = process.env.REACT_APP_JCB_ENV === "dev" ? "https://test-front-base.survey.work/login?type=childLogin&@" : "https://survey.work/login?type=childLogin&@";

  var appCodeImg = process.env.REACT_APP_JCB_ENV === "dev" ? appCodeDev : appCodeRelease;

  var _useDomain = useDomain(),
      getLoginDomain = _useDomain.getLoginDomain;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      fixLeft = _useState2[0],
      setFixLeft = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      selectKey = _useState4[0],
      setSelectKey = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      currentRole = _useState6[0],
      setCurrentRole = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      visible = _useState8[0],
      setVisible = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showDownload = _useState10[0],
      setShowDownload = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showcustomer = _useState12[0],
      setShowcustomer = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      userInfo = _useState14[0],
      setUserInfo = _useState14[1];
  // const [userNameInfo, setUserNameInfo] = useState("");


  var _useState15 = useState(""),
      _useState16 = _slicedToArray(_useState15, 2),
      projectName = _useState16[0],
      setProjectName = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      menus = _useState18[0],
      setMenus = _useState18[1];

  var _useState19 = useState(download),
      _useState20 = _slicedToArray(_useState19, 2),
      downloadInfo = _useState20[0],
      setDownloadInfo = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isFixed = _useState22[0],
      setIsFixed = _useState22[1];

  var B16 = getSpecialKeys("B16");
  var B40 = getSpecialKeys("B40");
  var B41 = getSpecialKeys("B41");
  // 需导航定制的企业id
  var companyIds = customNavCompanyIds.map(function (v) {
    return v.id;
  });
  var renderNavStyles = function renderNavStyles() {
    if (process.env.REACT_APP_TYPE === "city") {
      return {
        backgroundColor: "#BD192D",
        boxShadow: "0 1px 6px 0 #BD192D"
      };
    }
    if (process.env.REACT_APP_TYPE === "ny") {
      return {
        backgroundColor: "#07c160",
        boxShadow: "0 1px 6px 0 #07c160"
      };
    }
    if (companyIds.indexOf(getCompanyId()) > -1 || localStorage.getItem("themeColor")) {
      return {
        backgroundColor: localStorage.getItem("themeColor"),
        boxShadow: "0 1px 6px 0 " + localStorage.getItem("themeColor")
      };
    }
    return {
      boxShadow: "0 1px 6px 0 #306ed9"
    };
  };
  var navStyles = renderNavStyles();

  useEffect(function () {
    // 子项目
    if (isSubTitle) {
      updateTitleAndFavicon();
      // 换主题
      // if (localStorage.getItem('themeColor')) {
      //   console.log(localStorage.getItem('themeColor'), '主题色');
      //   less.modifyVars({
      //     '@primary-color': localStorage.getItem('themeColor'),
      //   });
      // }
      updateThemeColor();
    }
    getLogoutDomain();
  }, []);

  useEffect(function () {
    // 更新下载中心信息
    if (!isSubTitle) {
      setDownloadInfo(download);
    }
  }, [download]);

  useEffect(function () {
    var currentProjectId = getProjectId();
    if (currentProjectId) {
      userMsg(currentProjectId).then(function (res) {
        setUserInfo(res);
        // setUserNameInfo(res.name);
      });
    }
    if (!title) {
      // updateProjectName();
      getProjectName(currentProjectId).then(function (data) {
        setProjectName(data);
      });
    }
    if (currentProjectId && cache) {
      getNavMenuFromStorage(currentProjectId).then(function (data) {
        if (showWorkSpaceProjectIds.indexOf(currentProjectId) > -1) {
          setMenus(menusWorkSpace(currentProjectId, data));
        } else {
          setMenus(data);
        }
        updateSelectKey(data);
      });
    } else {
      updateSelectKey(menuList);
    }
    if (fixed) {
      window.addEventListener("scroll", scrollHandler);
      setIsFixed(true);
    }

    if (isSubTitle) {
      getCurrentProjectConfigured(currentProjectId).then(function (res) {
        setDownloadInfo(res);
      });
      // userMsg(currentProjectId).then((res) => {
      //   setUserNameInfo(res.name);
      // });
    }
  }, []);

  useEffect(function () {
    if (isFixed) {
      window.removeEventListener("scroll", scrollHandler);
    }
  }, [isFixed]);

  var scrollHandler = function scrollHandler() {
    var scrollLeft = document.documentElement.scrollLeft;
    setFixLeft(-scrollLeft);
  };
  var getCurrentMenu = function getCurrentMenu(key) {
    var currentMenu = void 0;
    var __getCurrentMenu = function __getCurrentMenu(menus) {
      if (menus) {
        for (var i = 0; i < menus.length; i++) {
          var menu = menus[i];
          if (!menu.children && menu.path === key) {
            currentMenu = menu;
            break;
          }
          if (menu.children) {
            __getCurrentMenu(menu.children);
            if (currentMenu) {
              break;
            }
          }
        }
      }
    };
    __getCurrentMenu(getMenu());
    return currentMenu;
  };
  var getMenu = function getMenu() {
    return cache ? menus : menuList;
  };
  var setNavMenuToStorage = function setNavMenuToStorage(projectId) {
    return getConfigNavMenu(projectId).then(function (data) {
      var storageMenu = JSON.parse(sessionStorage.getItem("menus") || "{}");
      storageMenu[projectId] = data;
      sessionStorage.setItem("menus", _JSON$stringify(storageMenu));
      return data;
    });
  };
  var getNavMenuFromStorage = function getNavMenuFromStorage(projectId) {
    var storageMenu = JSON.parse(sessionStorage.getItem("menus") || "{}");
    if (storageMenu[projectId]) {
      setNavMenuToStorage(projectId);
      return _Promise.resolve(storageMenu[projectId]);
    } else {
      return setNavMenuToStorage(projectId);
    }
  };

  var handleClick = function handleClick(e) {
    var currentMenu = getCurrentMenu(e.key);
    var linkType = currentMenu.linkType;
    var linkTarget = currentMenu.linkTarget;
    if (linkTarget === LINKTARGET.EXTERNAL) {
      if (linkType === LINKTYPE.NEW) {
        var pToken = qs.parse(e.key.split("?")[1]).token;
        if (pToken === "$ctoken") {
          window.open(e.key.replace("$ctoken", getToken()));
        } else {
          window.open(e.key);
        }
      } else {
        window.location.href = e.key;
      }
    } else {
      if (isSubTitle) {
        if (linkType === LINKTYPE.NEW) {
          window.open(window.location.origin + e.key);
        } else {
          window.location.href = window.location.origin + e.key;
        }
      } else {
        if (linkType === LINKTYPE.NEW) {
          window.open(window.location.origin + e.key);
        } else if (linkType === LINKTYPE.SUBPROJECT) {
          window.location.href = window.location.origin + e.key;
        } else {
          if (history) {
            history.push(e.key);
          } else {
            window.location.href = e.key;
          }
        }
      }
    }
  };
  var getSelectPath = function getSelectPath(menus) {
    var pathname = window.location.pathname;

    var selectKey_ = null;

    var __getSelectPath = function __getSelectPath(__menus) {
      if (__menus) {
        for (var i = 0; i < __menus.length; i++) {
          var menu = __menus[i];
          if (!menu.children && new RegExp("^" + pathname + "(.*|$)").test(menu.path)) {
            selectKey_ = menu.path;
            break;
          }
          if (menu.children) {
            __getSelectPath(menu.children);
            if (selectKey_) {
              break;
            }
          }
        }
      }
    };
    if (window.location.href.indexOf("/ucases?utype=scan") > -1) {
      selectKey_ = "/projects/" + getProjectId() + "/ucases?utype=scan";
    } else {
      __getSelectPath(menus);
    }
    return selectKey_;
  };
  var updateSelectKey = function updateSelectKey(menu) {
    var selectedKey = getSelectPath(menu);
    if (selectedKey) {
      setSelectKey(selectedKey);
    }
  };
  var updateProjectName = function updateProjectName() {
    return getProjectInfoById(getProjectId()).then(function (res) {
      setProjectName(res.title);
    });
  };

  var renderMenu = function renderMenu(menu) {
    return React.createElement(
      _Menu.Item,
      { key: menu.path, style: { marginRight: "40px" } },
      menu.name
    );
  };
  // subMenu样式
  var updateClassName = function updateClassName() {
    if (process.env.REACT_APP_TYPE === "city") {
      return "custom-sub-menu--cc-menu";
    }
    if (process.env.REACT_APP_TYPE === "ny") {
      return "custom-sub-menu--ny-menu";
    }
    return "custom-sub-menu--jcb-menu";
  };
  var renderSubMenu = function renderSubMenu(menu) {
    return React.createElement(
      SubMenu,
      {
        popupClassName: updateClassName,
        title: React.createElement(
          "span",
          null,
          React.createElement(
            "span",
            { style: { marginRight: "6px" } },
            menu.name
          ),
          React.createElement(DownOutlined, { style: { marginRight: "2px" } })
        )
      },
      menu.children.map(function (v) {
        return renderMenu(v);
      })
    );
  };
  var changeRole = function changeRole(role) {
    return function () {
      if (currentRole.id !== role.id) {
        setVisible(visible);
        setCurrentRole(role);
        if (onRoleChange) {
          onRoleChange(role);
        }
      }
    };
  };
  var getDownloadCenter = function getDownloadCenter() {
    var downloadItem = getMenu().filter(function (v) {
      return v.name === "下载中心";
    });
    return downloadItem && downloadItem.length > 0 ? downloadItem[0] : null;
  };

  var getLogoutDomain = function getLogoutDomain() {
    // 判断企业有没有配置退出登录url
    if (isCompany()) {
      getServiceList(getCompanyId()).then(function (data) {
        var homePage = data.filter(function (v) {
          return v.serviceType === -1 && v.custom;
        });
        if (homePage.length > 0) {
          localStorage.setItem("dygchome", homePage[0].serviceDomain);
        }
      });
    }
  };
  var clearSession = function clearSession(link) {
    window.location.href = link;
    removeToken();
    sessionStorage.clear();
    clearToken();
  };
  var onLogoutHandler = function onLogoutHandler() {
    if (process.env.REACT_APP_TYPE === "city") {
      clearSession(homeCity);
    } else if (process.env.REACT_APP_TYPE === "ny") {
      clearSession(homeNy);
    } else if (companyIds.indexOf(getCompanyId()) > -1 || localStorage.getItem("sign")) {
      // 应调转到相应的首页
      clearSession(localStorage.getItem("dygchome"));
    } else if (isSubTitle) {
      if (localStorage.getItem("dygchome")) {
        clearSession(localStorage.getItem("dygchome"));
      } else {
        getLoginDomain().then(function (v) {
          window.location.href = v;
        });
      }
    } else {
      if (localStorage.getItem("dygchome")) {
        clearSession(localStorage.getItem("dygchome"));
      } else if (onLogout) {
        if (userInfo.loginName && userInfo.loginName.includes("@")) {
          removeToken();
          sessionStorage.clear();
          clearToken();
          window.location.href = layoutUrl;
        } else {
          onLogout();
        }
      }
    }
  };
  var renderName = function renderName() {
    var v = sessionStorage.getItem("userName") || userName || userInfo.name;
    if (v && v.length > 2) {
      return v.substring(v.length - 2, v.length);
    }
    return v || "";
  };

  // 判断是否显示 客户端下载、下载中心、项目列表等导航右侧操作
  var isShowRightOpts = process.env.REACT_APP_JCB_ENV === "dev" ? (getProjectId() === "1280" || getProjectId() === "1285" || getProjectId() === "838") && window.location.href.indexOf("/workspace") > -1 || getProjectId() === "1299" : (getProjectId() === "1044" || getProjectId() === "1103" || getProjectId() === "1187") && window.location.href.indexOf("/workspace") > -1 || getProjectId() === "1158";
  // 判断是否进入工单列表等非工作台页面（显示下载中心、客户端下载）
  var isJsjbSysInner = process.env.REACT_APP_JCB_ENV === "dev" ? getProjectId() === "1280" || getProjectId() === "838" || getProjectId() === "1292" || getProjectId() === "1354" : getProjectId() === "1044" || getProjectId() === "1187" || getProjectId() === "1104" || getProjectId() === "1530";
  // 这部分项目不显示快速切换
  var isJsjb = process.env.REACT_APP_JCB_ENV === "dev" ? getProjectId() === "1280" || getProjectId() === "1285" || getProjectId() === "1299" || getProjectId() === "838" : getProjectId() === "1044" || getProjectId() === "1103" || getProjectId() === "1158" || getProjectId() === "1187";
  var isNotShowBackBtn = (process.env.REACT_APP_JCB_ENV === "dev" ? getProjectId() === "1285" : getProjectId() === "1103") || isShowWorkSpace(getProjectId());
  // 是否是上庄闭环检查项目
  var isSzhangBhjc = process.env.REACT_APP_JCB_ENV === "dev" ? getProjectId() === "1292" || getProjectId() === "1354" : getProjectId() === "1104" || getProjectId() === "1530";

  var photoBoxStyle = function photoBoxStyle() {
    if (companyIds.indexOf(getCompanyId()) > -1 || localStorage.getItem("themeColor")) {
      return { color: "" + localStorage.getItem("themeColor") };
    }
  };
  var renderUser = function renderUser() {
    return React.createElement(
      "div",
      { className: "user-info" },
      React.createElement(
        _Dropdown,
        {
          overlayClassName: "dropdown--jcb-menu",
          overlay: React.createElement(
            _Menu,
            {
              style: {
                width: "138px",
                // height: "54px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 15px"
              }
            },
            React.createElement(
              _Menu.Item,
              {
                key: "logout",
                onClick: onLogoutHandler,
                style: {
                  display: "flex",
                  alignItems: "center",
                  width: "100%"
                }
              },
              React.createElement(LogoutOutlined, {
                style: {
                  fontSize: "15px",
                  color: "#8c8c8c"
                }
              }),
              "\u9000\u51FA\u767B\u5F55"
            ),
            getProjectId() === "1" && userInfo.sfId && userInfo.loginName && userInfo.loginName.includes("@") && React.createElement(
              _Menu.Item,
              {
                key: "logout",
                onClick: function onClick() {
                  window.location.href = window.location.protocol + "//" + window.location.host + ("/projects/" + getProjectId() + "/updateuser");
                },
                style: {
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  width: "100%"
                }
              },
              React.createElement(FormOutlined, {
                style: {
                  fontSize: "15px",
                  color: "#8c8c8c"
                }
              }),
              "\u4FEE\u6539\u59D3\u540D"
            ),
            ((getProjectId() === "3179" || getProjectId() === "3327" || getProjectId() === "8" || getProjectId() === "472") && (isJcbUser() || sessionStorage.getItem("login_from_jcb")) || getProjectId() === "1" && userInfo.sfId && userInfo.loginName && userInfo.loginName.includes("@")) && React.createElement(
              _Menu.Item,
              {
                key: "logout",
                onClick: function onClick() {
                  window.location.href = window.location.protocol + "//" + window.location.host + ("/projects/" + getProjectId() + "/updatepwd");
                },
                style: {
                  paddingTop: "0",
                  display: "flex",
                  alignItems: "center",
                  width: "100%"
                }
              },
              React.createElement(FormOutlined, {
                style: {
                  fontSize: "15px",
                  color: "#8c8c8c"
                }
              }),
              "\u4FEE\u6539\u5BC6\u7801"
            )
          )
        },
        React.createElement(
          "div",
          { style: { cursor: "pointer" } },
          avatar || projectIds["shangzhang"].indexOf(getProjectId()) > -1 || process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && companyIds.indexOf(getCompanyId()) === -1 && !localStorage.getItem("sign") && !localStorage.getItem("themeColor") ? React.createElement(_Avatar, {
            icon: React.createElement(UserOutlined, { style: { color: "#fff" } }),
            style: { marginRight: "8px" },
            src: avatar
          }) : React.createElement(
            "div",
            { className: "photo-box", style: photoBoxStyle() },
            renderName()
          )
        )
      ),
      React.createElement(
        "div",
        null,
        (sessionStorage.getItem("userName") || userName || userInfo.name) && React.createElement(
          "span",
          { className: "user" },
          sessionStorage.getItem("userName") || userName || userInfo.name
        ),
        allRoles.length > 0 && React.createElement(
          "div",
          {
            onClick: function onClick() {
              setVisible(true);
            },
            className: "role"
          },
          React.createElement(
            "span",
            null,
            currentRole.name
          ),
          ">"
        )
      )
    );
  };
  // 上庄
  var backProject = process.env.REACT_APP_JCB_ENV === "dev" ? "1285" : "1103";
  var renderAppSrc = function renderAppSrc() {
    if (process.env.REACT_APP_TYPE === "city") {
      return appCodeImg;
    }
    if (process.env.REACT_APP_TYPE === "ny") {
      return appCodeNy;
    }
    return "/api/v1/utils/qrcode?url=" + (window.location.protocol + "//" + window.location.host + downloadInfo.app.file + "&projectId=" + (getCompanyId() || "")) + "&height=200&width=200";
  };

  return React.createElement(
    "div",
    { className: "custom-menu--jcb-menu" },
    type === "menu" && React.createElement(
      "div",
      {
        style: _extends({
          minWidth: minWidth + "px",
          left: fixed ? fixLeft : null
        }, navStyles),
        className: cx({
          "navbar-container--jcb-menu": true,
          "fixed-nav": fixed,
          "navbar--jcb": process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && projectIds["shangzhang"].indexOf(getProjectId()) === -1 && companyIds.indexOf(getCompanyId()) === -1 && !localStorage.getItem("themeColor") && !localStorage.getItem("sign"),
          "navbar--shangzhang": projectIds["shangzhang"].indexOf(getProjectId()) > -1
        })
      },
      React.createElement(
        "div",
        { className: "left-box" },
        (isSubTitle || dashboardUrl) && hasSide && !isJcbUser() && !sessionStorage.getItem("login_from_jcb") && process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && !isJsjb && !isSzhangBhjc && companyIds.indexOf(getCompanyId()) === -1 && !localStorage.getItem("sign") && React.createElement(MenuTrigger, {
          onToggle: onToggle,
          collapsed: collapsed,
          B41: B41
        }),
        (process.env.REACT_APP_TYPE === "city" || process.env.REACT_APP_TYPE === "ny" || localStorage.getItem("sign") || companyIds.indexOf(getCompanyId()) > -1) && !isOnlyShowJcb(getCompanyId(), getProjectId()) && !isBackProjects(getCompanyId()) && React.createElement(MenuTrigger, {
          city: true,
          onToggle: function onToggle() {
            if (isSubTitle) {
              window.location.href = window.location.origin + "/dashboard";
            } else {
              if (history) {
                history.push(homeUrl);
              } else {
                window.location.href = homeUrl;
              }
            }
          }
        }),
        (isInnerWorkSpace(getProjectId()) || (isJsjb || isSzhangBhjc) && !isNotShowBackBtn) && React.createElement(MenuTrigger, {
          jsjb: true,
          onToggle: function onToggle(params) {
            var wProjectId = isInnerWorkSpace(getProjectId());
            if (isJsjb || isSzhangBhjc) {
              if (params) {
                window.location.href = "/projects/" + backProject + "/workspace?show=subSpace";
              } else {
                window.location.href = "/projects/" + backProject + "/workspace";
              }
            } else {
              window.location.href = "/projects/" + wProjectId + "/workspace";
            }
          }
        }),
        process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && !isJsjb && companyIds.indexOf(getCompanyId()) === -1 && !localStorage.getItem("sign") ? React.createElement(
          "div",
          { className: "left-menu" },
          React.createElement("img", {
            className: "logo",
            src: logo ? logo : B40.value || showLogo,
            height: "20"
          }),
          React.createElement("span", { className: "divide" }),
          React.createElement(
            "h2",
            { className: "menu-title" },
            title || projectName
          ),
          isGrayUser() && React.createElement(
            "div",
            { className: "gray" },
            "\u5185\u6D4B\u7248"
          )
        ) : React.createElement(
          "div",
          { className: "left-menu" },
          React.createElement(
            "h2",
            { className: "menu-title" },
            projectName
          )
        ),
        React.createElement(
          _Menu,
          {
            selectedKeys: [selectKey],
            className: "navbar-menu",
            onClick: handleClick,
            mode: "horizontal"
          },
          getMenu().map(function (item) {
            if (item.name !== "下载中心") {
              return item.children && item.children.length > 0 ? renderSubMenu(item) : renderMenu(item);
            }
            return null;
          })
        )
      ),
      !isShowRightOpts && !isNotShowBackBtn ? React.createElement(
        "div",
        { className: "right-menu" },
        projectIds["shangzhang"].indexOf(getProjectId()) > -1 && React.createElement(
          "div",
          {
            className: "workspace",
            onClick: function onClick() {
              window.location.href = "/projects/" + backProject + "/workspace";
            }
          },
          "\u5DE5\u4F5C\u53F0"
        ),
        getProjectId() !== "1" && React.createElement(
          "div",
          { className: "return-btn-con download-btn-con" },
          React.createElement("img", {
            className: "logo",
            alt: "\u5BA2\u670D",
            title: "\u5BA2\u670D",
            src: customerImg,
            style: {
              cursor: "pointer",
              height: "30px",
              width: "30px",
              marginRight: "15px"
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              setShowcustomer(!showcustomer);
            }
          }),
          React.createElement(
            "div",
            {
              // ref={ref}
              className: cx({
                "display-none": !showcustomer,
                "download-panel-con": true
              })
            },
            React.createElement(
              "div",
              { className: "download-panel" },
              React.createElement(
                "div",
                { className: "download-item" },
                React.createElement(
                  "div",
                  { className: "qr-container" },
                  React.createElement("img", {
                    src: kfImg,
                    style: {
                      marginBottom: "6px",
                      width: "128px",
                      height: "128px"
                    }
                  })
                ),
                React.createElement(
                  "div",
                  { className: "download-content" },
                  React.createElement(
                    "p",
                    null,
                    "\u5982\u9700\u5E2E\u52A9\uFF0C\u8BF7\u5FAE\u4FE1\u626B\u7801\u54A8\u8BE2"
                  )
                )
              )
            )
          )
        ),
        getDownloadCenter() && React.createElement(
          "div",
          { className: "return-btn-con download-btn-con" },
          React.createElement("img", {
            className: "logo",
            style: {
              cursor: "pointer",
              height: "23px",
              marginRight: "15px"
            },
            alt: "\u4E0B\u8F7D\u4E2D\u5FC3",
            title: "\u4E0B\u8F7D\u4E2D\u5FC3",
            src: cdownloadImg,
            onClick: function onClick() {
              window.location.href = getDownloadCenter().path;
            }
          })
        ),
        (homeUrl || isSubTitle) && isShowProjectList(userInfo) && DEAlDOMAIN !== CURRENTDOMAIN && process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && !isJsjbSysInner && !isSzhangBhjc && companyIds.indexOf(getCompanyId()) === -1 && !localStorage.getItem("sign") && getProjectId() !== "1" && document.location.hostname !== "jc.smartcity.survey.work" && !isInnerWorkSpace(getProjectId()) && React.createElement(
          "div",
          { className: "return-btn-con download-btn-con" },
          React.createElement("img", {
            className: "logo",
            style: {
              cursor: "pointer",
              height: "23px",
              marginRight: "15px"
            },
            alt: "\u9879\u76EE\u5217\u8868",
            title: "\u9879\u76EE\u5217\u8868",
            src: projectsImg,
            onClick: function onClick() {
              if (isSubTitle) {
                window.location.href = window.location.origin + "/dashboard";
              } else {
                if (history) {
                  history.push(homeUrl);
                } else {
                  window.location.href = homeUrl;
                }
              }
            }
          })
        ),
        downloadVisible && DEAlDOMAIN !== CURRENTDOMAIN && isShowDownload(userInfo) && React.createElement(
          "div",
          { className: "return-btn-con download-btn-con" },
          React.createElement("img", {
            className: "logo",
            alt: "\u5BA2\u6237\u7AEF\u4E0B\u8F7D",
            title: "\u5BA2\u6237\u7AEF\u4E0B\u8F7D",
            src: downloadImg,
            style: {
              cursor: "pointer",
              height: "23px",
              width: "30px"
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              setShowDownload(!showDownload);
            }
          }),
          React.createElement(
            "div",
            {
              // ref={ref}
              className: cx({
                "display-none": !showDownload,
                "download-panel-con": true
              })
            },
            React.createElement(
              "div",
              { className: "download-panel" },
              downloadInfo.app && React.createElement(
                "div",
                { className: "download-item" },
                React.createElement(
                  "div",
                  {
                    className: "download-panel-name",
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center"
                    }
                  },
                  downloadInfo.app.name.replace("明察暗访-", "")
                ),
                React.createElement(
                  "div",
                  { className: "qr-container" },
                  React.createElement("img", {
                    src: renderAppSrc(),
                    style: {
                      width: "128px",
                      height: "128px",
                      marginBottom: "6px"
                    }
                  })
                ),
                React.createElement(
                  "div",
                  { className: "download-content" },
                  React.createElement(
                    "div",
                    { className: "download-sub-title" },
                    !isJsjbSysInner ? "用于实地检查上报案件" : "责任单位移动端APP"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u624B\u673A\u626B\u7801\u4E8C\u7EF4\u7801\u4E0B\u8F7D"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u5B89\u53538.0\u53CA\u4EE5\u4E0A\u7248\u672C\u9002\u7528"
                  ),
                  !getSpecial() && React.createElement(
                    "p",
                    null,
                    "\u7248\u672C\uFF1A",
                    downloadInfo.app.version
                  ),
                  !getSpecial() && React.createElement(
                    "p",
                    null,
                    "\u66F4\u65B0\u65F6\u95F4\uFF1A",
                    downloadInfo.app.updateDate
                  )
                )
              ),
              downloadInfo.weapp && (B16.value || !localStorage.getItem("isSpecial")) && process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && !isJsjbSysInner && React.createElement(
                "div",
                { className: "download-item" },
                React.createElement(
                  "div",
                  {
                    className: "download-panel-name",
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      textIndent: "0"
                    }
                  },
                  downloadInfo.weapp.name.replace("明察暗访", "")
                ),
                React.createElement(
                  "div",
                  { className: "qr-container" },
                  React.createElement("img", {
                    src: !B16.value ? downloadInfo.weapp.file : B16.value,
                    style: {
                      marginBottom: "6px",
                      width: "128px",
                      height: "128px"
                    }
                  })
                ),
                React.createElement(
                  "div",
                  { className: "download-content" },
                  React.createElement(
                    "div",
                    { className: "download-sub-title" },
                    "\u8D23\u4EFB\u4E3B\u4F53\u63D0\u4EA4\u5904\u7F6E\u4FE1\u606F"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u5FAE\u4FE1\u626B\u7801\u6253\u5F00\u5373\u53EF\u4F53\u9A8C"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u7248\u672C\uFF1A",
                    downloadInfo.weapp.version
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u66F4\u65B0\u65F6\u95F4\uFF1A",
                    downloadInfo.weapp.updateDate
                  )
                )
              ),
              downloadInfo.downLoader && React.createElement(
                "div",
                { className: "download-item" },
                React.createElement(
                  "div",
                  {
                    className: "download-panel-name",
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      textIndent: "0"
                    }
                  },
                  downloadInfo.downLoader.name.replace("明察暗访", "")
                ),
                React.createElement(
                  "div",
                  { className: "qr-container" },
                  React.createElement("img", {
                    src: localStorage.getItem("isSpecial") || process.env.REACT_APP_TYPE === "city" || process.env.REACT_APP_TYPE === "ny" ? downloadPngd : downloadPng,
                    style: {
                      marginBottom: "6px",
                      width: "128px",
                      height: "128px"
                    }
                  })
                ),
                React.createElement(
                  "div",
                  { className: "download-content" },
                  React.createElement(
                    "div",
                    { className: "download-sub-title" },
                    "\u7528\u4E8E\u6848\u4EF6\u4FE1\u606F\u4E0B\u8F7D"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u7248\u672C\uFF1A",
                    downloadInfo.downLoader.version
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u66F4\u65B0\u65F6\u95F4\uFF1A",
                    downloadInfo.downLoader.updateDate
                  )
                ),
                React.createElement(
                  "a",
                  {
                    className: process.env.REACT_APP_TYPE !== "city" ? "download" : "download-cc",
                    href: downloadInfo.downLoader.file,
                    download: "JCBDownLoader"
                  },
                  "\u4E0B\u8F7D"
                )
              ),
              !getSpecial() && process.env.REACT_APP_TYPE !== "city" && process.env.REACT_APP_TYPE !== "ny" && !isJsjbSysInner && React.createElement(
                "div",
                { className: "download-item" },
                React.createElement(
                  "div",
                  {
                    className: "download-panel-name",
                    style: {
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      textIndent: "0"
                    }
                  },
                  "\u516C\u4F17\u53F7"
                ),
                React.createElement(
                  "div",
                  { className: "qr-container" },
                  React.createElement("img", {
                    src: qrCode,
                    style: {
                      marginBottom: "6px",
                      width: "128px",
                      height: "128px"
                    }
                  })
                ),
                React.createElement(
                  "div",
                  { className: "download-content" },
                  React.createElement(
                    "div",
                    { className: "download-sub-title" },
                    "\u5173\u6CE8\u6211\u4EEC\u4E86\u89E3\u66F4\u591A\u8D44\u8BAF"
                  ),
                  React.createElement(
                    "p",
                    null,
                    "\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8"
                  )
                )
              )
            )
          )
        ),
        (!!homeUrl || isSubTitle || downloadVisible) && DEAlDOMAIN !== CURRENTDOMAIN && React.createElement("span", { className: "divide" }),
        renderUser()
      ) : React.createElement(
        "div",
        { className: "right-menu" },
        " ",
        renderUser()
      )
    ),
    type === "title" && React.createElement(
      "div",
      {
        style: { minWidth: minWidth + "px", left: fixed ? fixLeft : null },
        className: cx({
          "simple-title-con": true,
          "fixed-nav": fixed
        })
      },
      React.createElement(
        "div",
        null,
        React.createElement(
          "span",
          { className: "simple-title" },
          title || projectName
        ),
        React.createElement(
          "span",
          { style: { marginRight: "14px" } },
          "|"
        ),
        React.createElement(
          "span",
          { className: "module-name" },
          moduleName
        )
      )
    ),
    fixed && React.createElement("div", { style: { minWidth: minWidth + "px" }, className: "shadow" }),
    React.createElement(
      _Modal,
      {
        visible: visible,
        title: "\u8BF7\u9009\u62E9\u5F53\u524D\u767B\u5F55\u89D2\u8272",
        footer: null,
        closable: false,
        onCancel: function onCancel() {
          setVisible(false);
        }
      },
      allRoles.map(function (role) {
        return React.createElement(
          "div",
          { className: "role-item" },
          React.createElement(
            "div",
            { onClick: changeRole(role) },
            React.createElement(
              "span",
              { className: "role-item-name" },
              role.name
            ),
            currentRole.id === role.id && React.createElement(
              _Tag,
              { color: "blue", style: { marginLeft: "7px" } },
              "\u5F53\u524D\u9009\u62E9"
            )
          ),
          React.createElement(RightOutlined, null)
        );
      })
    )
  );
};

__signature__(NavMenuCopy, "useCustomized{{ isCompany }}\nuseDomain{{ getLoginDomain }}\nuseState{[fixLeft, setFixLeft](0)}\nuseState{[selectKey, setSelectKey](\"\")}\nuseState{[currentRole, setCurrentRole]({})}\nuseState{[visible, setVisible](false)}\nuseState{[showDownload, setShowDownload](false)}\nuseState{[showcustomer, setShowcustomer](false)}\nuseState{[userInfo, setUserInfo]({})}\nuseState{[projectName, setProjectName](\"\")}\nuseState{[menus, setMenus]([])}\nuseState{[downloadInfo, setDownloadInfo](download)}\nuseState{[isFixed, setIsFixed](false)}\nuseEffect{}\nuseEffect{}\nuseEffect{}\nuseEffect{}", function () {
  return [useCustomized, useDomain];
});

var _default = NavMenuCopy;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(updateTitleAndFavicon, "updateTitleAndFavicon", "src/components/NavMenuCopy.js");
  reactHotLoader.register(updateThemeColor, "updateThemeColor", "src/components/NavMenuCopy.js");
  reactHotLoader.register(getProjectName, "getProjectName", "src/components/NavMenuCopy.js");
  reactHotLoader.register(DEAlDOMAIN, "DEAlDOMAIN", "src/components/NavMenuCopy.js");
  reactHotLoader.register(CURRENTDOMAIN, "CURRENTDOMAIN", "src/components/NavMenuCopy.js");
  reactHotLoader.register(LINKTYPE, "LINKTYPE", "src/components/NavMenuCopy.js");
  reactHotLoader.register(LINKTARGET, "LINKTARGET", "src/components/NavMenuCopy.js");
  reactHotLoader.register(SubMenu, "SubMenu", "src/components/NavMenuCopy.js");
  reactHotLoader.register(NavMenuCopy, "NavMenuCopy", "src/components/NavMenuCopy.js");
  reactHotLoader.register(_default, "default", "src/components/NavMenuCopy.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();